import { Row, Col } from 'react-bootstrap';

export default function PlanosCargosCarreiras() {
    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/pessoal">Gestão de Pessoas</a> / Planos de Cargos e Carreiras</small></p>
            <h1>Planos de Cargos e Carreiras</h1>
            <div>
            <article className="wrapper-three-col three-col article">

<div className="quadro-remuneracao">
  <ul>
    <li><a href="#tab1">DAS DISPOSIÇÕES PRELIMINARES</a></li>
    <li><a href="#tab2">DA ESTRUTURAÇÃO</a></li>
    <li><a href="#tab3">DOS CARGOS, ESPECIALIDADES E REMUNERAÇÃO</a></li>
    <li><a href="#tab4">QUADRO DE PESSOAL EFETIVO DA ALEPE</a></li>
    <li><a href="#tab5">ESCOLARIDADE E ATRIBUIÇÕES GERAIS DOS CARGOS EFETIVOS</a></li>
  </ul>
</div>

<div className="clearfix"><br/></div>

 <div className="row">
     <div className="news-box-inner-footer">
          <a href="https://www.alepe.pe.gov.br/wp-content/uploads/2015/05/atribuicoes.pdf" rel="noopener" target="_blank" className="download" title="Download em PDF"><span className="icon icon-download"></span>Faça o download dessa Lei (formato PDF)</a>
        </div>
     <br/>
    </div>

 <div className="texto-lei-scroll">
    <div className="proposicao-list-header">
    <p>Este texto não substitui o publicado pelo Diário Oficial.</p>
    <h2 className="title">Lei 15.160/2013</h2>
  </div>





<div className="WordSection1">

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b>LEI Nº 15.160, DE
27 DE NOVEMBRO DE 2013.</b></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b>&nbsp;</b></p>

<p className="MsoNormal" originalstyle="margin-left:198.0pt;text-align:justify">Dispõe sobre
o Plano de Cargos e Carreiras dos servidores efetivos da Assembleia Legislativa
do Estado de Pernambuco e dá outras providências.</p>

<p className="MsoNormal" originalstyle="text-align:justify">&nbsp;</p>

<p className="MsoNormal" originalstyle="text-align:justify">O PRESIDENTE DA ASSEMBLEIA
LEGISLATIVA DO ESTADO DE PERNAMBUCO:</p>

<p className="MsoNormal" originalstyle="text-align:justify">Faço saber que tendo em vista o
disposto nos §§ 6º e 8º do art. 23, da Constituição do Estado, o Poder
Legislativo decreta e eu promulgo a seguinte Lei:</p>

<p className="MsoNormal" originalstyle="text-align:justify">&nbsp;</p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">CAPÍTULO I</span></b></p>

<p className="MsoNormal" id="tab1" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">DAS DISPOSIÇÕES PRELIMINARES</span></b></p>

<p className="MsoNormal" originalstyle="margin-left:1.0cm;text-align:justify;text-indent:1.0cm"><b><span originalstyle="color:black">&nbsp;</span></b></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 1º O ingresso na carreira correspondente aos cargos
efetivos do Quadro de Pessoal da Assembleia Legislativa dar-se-á no primeiro
nível do subsídio da classNamee inicial do respectivo cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Parágrafo único. As especialidades dos cargos de provimento
efetivo da Assembleia Legislativa, com as respectivas atribuições passam a ser
as constantes nos Anexo I e II desta lei.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:30.0pt"><span originalstyle="color:black">Art. 2º O edital de concurso público para provimento de
cargos efetivos no Quadro de Pessoal da Assembleia Legislativa poderá prever:</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black"> </span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">I - áreas de seleção distintas para as especialidades
previstas no Anexo I desta Lei, em razão das características da atividade a ser
desempenhada;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">II - necessidade de realização de treinamento específico
para o desempenho das atribuições do cargo;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">III - restrições e condicionantes decorrentes de atividade
inerente ao cargo a ser provido.</span></p>

<p className="MsoNormal" originalstyle="margin-left:1.0cm;text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">CAPÍTULO II</span></b></p>

<p className="MsoNormal" id="tab2" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">DA ESTRUTURAÇÃO</span></b></p>

<p className="MsoNormal" originalstyle="margin-left:1.0cm;text-align:justify;text-indent:1.0cm"><b><span originalstyle="color:black">&nbsp;</span></b></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 3º A Carreira do Quadro de Pessoal da Assembleia
Legislativa do Estado de Pernambuco se organiza em quatro classNamees, com cargos
únicos e distintos entre si pelas respectivas especialidades.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 4º Para os efeitos desta Lei, considera-se:</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">I - Carreira - plano geral de atribuições, subsídios e
vantagens de determinado grupo profissional, organizado em classNamees, cargos e
especialidades, níveis de escolaridade e graus de especialização, implicando
estágios de complexidade e retribuição crescentes;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">II - classNamee - formada por um cargo único restrito ou amplo,
que abrange as diversas especialidades ou atribuições;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">III - Cargo - conjunto de elementos iguais quanto à
natureza, grau de responsabilidade e complexidade das funções desempenhadas;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">IV - Nível - nível de remuneração em escala progressiva,
dentro de cada classNamee;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">V - Especialidade - conjunto de elementos que caracterizam
cada área de atuação dentro de um cargo e o diferencia dos demais, incluindo,
entre outros, os seguintes elementos:</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">a) síntese de atribuições inerentes ao cargo;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">b) indicação dos requisitos referentes ao nível de
escolaridade para o provimento;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">c) indicação das linhas de progressão;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">d) condições especiais de trabalho;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">VI - Quadro de Pessoal - formado pela totalidade dos cargos
efetivos que integram a estrutura organizacional da Assembleia Legislativa do
Estado de Pernambuco. </span></p>

<p className="MsoNormal" originalstyle="margin-left:1.0cm;text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">CAPÍTULO III</span></b></p>

<p className="MsoNormal" id="tab3" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">DOS CARGOS, ESPECIALIDADES E REMUNERAÇÃO</span></b></p>

<p className="MsoNormal" originalstyle="margin-left:1.0cm;text-align:justify;text-indent:1.0cm"><b><span originalstyle="color:black">&nbsp;</span></b></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 5º A carreira do Quadro de Pessoal da Assembleia
Legislativa do Estado de Pernambuco compreende quatro classNamees, com cargos
únicos, integradas e com as atribuições, exigências de escolaridade e formação
específica estabelecidos no anexo II desta Lei.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">I - classNamee I</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Cargo Amplo: Analista Legislativo:</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Especialidades</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">1. Administração;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">2. Informática;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">3. Assistência Social;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">4. Auditoria;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">5. Biblioteconomia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">6. Consultoria Legislativa;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">7. Contabilidade;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">8. Enfermagem;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">9. Engenharia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">10. Comunicação Social;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">11. Medicina;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">12. Odontologia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">13. Pedagogia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">14. Psicologia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">15. Relações Públicas;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">16. Historiador.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">II - classNamee II</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Cargo Amplo: Técnico Legislativo:</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Especialidades</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">1. Processo Legislativo;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">2. Informática;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">3. Taquigrafia.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">III - classNamee III</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Cargo Restrito: Policial Legislativo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">IV - classNamee IV</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Cargo Restrito: Agente Legislativo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Parágrafo único. Conforme definido no <i>caput</i>, nos
seus incisos, ficam alteradas as denominações dos seguintes cargos, constantes
da <a href="http://legis.alepe.pe.gov.br/?lo127772005">Lei nº 12.777, de 24 de março de 2005</a>:</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">I - de Administrador, para Analista Legislativo,
especialidade Administração;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">II - de Analista Legislativo, para Analista Legislativo,
especialidade Consultoria Legislativa;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">III - de Analista de Sistemas, para Analista Legislativo,
especialidade Informática;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">IV - de Assistente Social, para Analista Legislativo,
especialidade Assistência Social;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">V - de Auditor, para Analista Legislativo, especialidade
Auditoria;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">VI - de Bibliotecário, para Analista Legislativo,
especialidade Biblioteconomia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">VII - de Contador, para Analista Legislativo, especialidade
Contabilidade;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">VIII - de Economista, para Analista Legislativo,
especialidade Consultoria Legislativa;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">IX - de Engenheiro, para Analista Legislativo,
especialidade Engenharia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">X - de Enfermeiro, para Analista Legislativo, especialidade
Enfermagem;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XI - de Jornalista e de Comunicador Visual, para Analista
Legislativo, especialidade Comunicação Social;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XII - de Assistente de Saúde, para Analista Legislativo,
especialidade Medicina;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XIII - de Odontólogo, para Analista Legislativo,
especialidade Odontologia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XIV - de Pedagogo, para Analista Legislativo, especialidade
Pedagogia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XV - de Psicólogo, para Analista Legislativo, especialidade
Psicologia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XVI - de Relações Públicas, para Analista Legislativo,
especialidade Relações Públicas;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XVII - de Técnico de Administração, de Técnico Legislativo
e de Técnico de Contabilidade, para Técnico Legislativo, especialidade Processo
Legislativo;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XVIII - de Digitador, Programador de Computador e Operador
de Terminal de Computador, para Técnico Legislativo, especialidade Informática;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XIX - de Taquígrafo, para Técnico Legislativo,
especialidade Taquigrafia;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">XX - de Agente de Polícia Legislativa, para Policial
Legislativo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 6º A nomeação para os cargos de provimento efetivo,
estruturados conforme o art. 5º desta Lei, dar-se-á no primeiro nível da classNamee
e dependerá da prévia habilitação em concurso público de provas ou de provas e
títulos, obedecidos a ordem de classNameificação e o prazo de validade do concurso.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 7º Os servidores remanescentes dos cargos extintos
pelo art. 30 da <a href="http://legis.alepe.pe.gov.br/?lo127772005">Lei nº 12.777, de 24 de março de 2005,</a>
podem ser aproveitados para o desempenho das atividades inerentes ao cargo de
Agente Legislativo a critério da Administração, obedecida a qualificação
exigida para o cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 8º A nova estrutura de cargos efetivos da Assembleia
Legislativa do Estado de Pernambuco, bem como suas atribuições, é a constante
dos Anexos I e II a presente Lei.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 9º Os servidores de que trata o art. 5º, inciso III,
serão lotados, exclusivamente, na Assistência Militar e de Segurança
Legislativa, sendo vedada a sua lotação em qualquer outro setor constante da
estrutura administrativa da Assembleia Legislativa do Estado de Pernambuco.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Parágrafo único. O disposto no <i>caput</i> deste artigo
não se aplica em caso de exercício de função de direção e chefia.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 10. O cargo de Agente Legislativo seguirá a tabela
remuneratória do cargo de Policial Legislativo. </span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 11. Esta Lei entra em vigor na data de sua publicação.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">Art. 12 Ficam revogados os arts. 1º ao 5º da <a href="http://legis.alepe.pe.gov.br/?lo127772005">Lei nº 12.777, de 23 de março de 2005</a>.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:1.0cm">Palácio Joaquim
Nabuco, Recife, 27 de novembro do ano de 2013, 197º da Revolução Republicana
Constitucionalista e 192º da Independência do Brasil.</p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="font-size:19.0pt;font-family:&quot;Verdana&quot;,&quot;sans-serif&quot;">&nbsp;</span></b></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="font-size:11.5pt">GUILHERME UCHÔA</span></b></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center">Presidente<b> </b></p>

<span originalstyle="font-size:12.0pt;font-family:&quot;Times New Roman&quot;,&quot;serif&quot;"><br clear="all" originalstyle="page-break-before:always" />
</span>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">ANEXO I</span></b></p>

<p className="MsoNormal" id="tab4" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">QUADRO DE PESSOAL EFETIVO DA ALEPE</span></b></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">&nbsp;</span></b></p>

<table className="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" originalstyle="margin-left:20.7pt;border-collapse:collapse">
<tbody><tr originalstyle="height:16.0pt">
<td width="192" originalstyle="width:144.15pt;border:solid windowtext 1.5pt;background:  #D2D2D2;padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">CARGO</span></p>
</td>
<td width="317" originalstyle="width:237.45pt;border:solid windowtext 1.5pt;border-left:  none;background:#D2D2D2;padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ESPECIALIDADE</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border:solid windowtext 1.5pt;border-left:  none;background:#D2D2D2;padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">Nº VAGAS</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="192" rowspan="16" originalstyle="width:144.15pt;border-top:none;border-left:  solid windowtext 1.5pt;border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ANALISTA LEGISLATIVO</span></p>
</td>
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">BIBLIOTECONOMIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">06</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">CONSULTORIA LEGISLATIVA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">80</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">PEDAGOGIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">03</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ADMINISTRAÇÃO</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">04</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">CONTABILIDADE</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">08</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">AUDITORIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">03</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">MEDICINA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">15</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ODONTOLOGIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">03</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">PSICOLOGIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">03</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ASSISTÊNCIA SOCIAL</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">03</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ENFERMAGEM</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">02</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">ENGENHARIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">04</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">COMUNICAÇÃO SOCIAL</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">40</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">INFORMÁTICA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">12</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">HISTORIADOR</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">02</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.5pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">RELAÇÕES PÚBLICAS</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.5pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">02</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="192" rowspan="3" originalstyle="width:144.15pt;border-top:none;border-left:  solid windowtext 1.5pt;border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">TÉCNICO LEGISLATIVO</span></p>
</td>
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">INFORMÁTICA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">20</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.0pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">TAQUIGRAFIA</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.0pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">20</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.5pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">PROCESSO LEGISLATIVO</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.5pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">160</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="192" originalstyle="width:144.15pt;border-top:none;border-left:solid windowtext 1.5pt;  border-bottom:solid black 1.5pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">POLICIAL LEGISLATIVO</span></p>
</td>
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.5pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">-</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.5pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">30</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="192" originalstyle="width:144.15pt;border-top:none;border-left:solid windowtext 1.5pt;  border-bottom:solid black 1.5pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">AGENTE LEGISLATIVO</span></p>
</td>
<td width="317" originalstyle="width:237.45pt;border-top:none;border-left:none;  border-bottom:solid black 1.5pt;border-right:solid windowtext 1.5pt;  padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">-</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid black 1.5pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">60</span></p>
</td>
</tr>
<tr originalstyle="height:16.0pt">
<td width="509" colspan="2" originalstyle="width:381.6pt;border:solid windowtext 1.5pt;  border-top:none;padding:0cm 5.4pt 0cm 5.4pt;height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">TOTAL DE EFETIVOS</span></p>
</td>
<td width="81" originalstyle="width:60.5pt;border-top:none;border-left:none;border-bottom:  solid windowtext 1.5pt;border-right:solid windowtext 1.5pt;padding:0cm 5.4pt 0cm 5.4pt;  height:16.0pt">
<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="color:black">480</span></p>
</td>
</tr>
</tbody></table>

<b><span originalstyle="font-size:12.0pt;font-family:&quot;Times New Roman&quot;,&quot;serif&quot;;color:black"><br clear="all" originalstyle="page-break-before:always"/>
</span></b>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">ANEXO II</span></b></p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">&nbsp;</span></b></p>

<p className="MsoNormal" id="tab5" align="center" originalstyle="text-align:center"><b><span originalstyle="color:black">ESCOLARIDADE E ATRIBUIÇÕES GERAIS DOS CARGOS EFETIVOS</span></b></p>

<p className="MsoNormal" originalstyle="text-align:justify"><b><span originalstyle="color:black">&nbsp;</span></b></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">1.
classNameE I</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">CARGO:
ANALISTA LEGISLATIVO</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
ADMINISTRAÇÃO</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Administração
de Empresas ou em Administração Pública e registro no órgão de fiscalização
profissional competente.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">elaborar, executar e acompanhar projetos,
pesquisas e estudos nas áreas de material, serviço, patrimônio, sistemas de
informações e organizações e métodos, voltados para o aprimoramento
organizacional; colher, sistematizar e interpretar dados, informações e
indicadores referentes a desempenho setorial, custos, resultados, preços e
cotações; prestar assessoramento nos processos de compra e de contratação de
bens e serviços; - assessorar a gestão e a fiscalização de contratos; auxiliar
e prestar assessoramento nas atividades de suporte logístico da instituição;
emitir pareceres e laudos; realizar outras atividades compatíveis com a
especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
INFORMÁTICA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Ciência da
Computação, em Sistemas de Informação ou em áreas afins ou com especialização
na área de Computação.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:</span><span originalstyle="color:black"> desenvolver, implantar e manter sistemas informatizados;
especificar e implantar produtos e serviços de informática; configurar e
administrar a infraestrutura de informática da instituição; oferecer suporte a
usuários de informática e capacitá-los; realizar pesquisas, avaliações e
estudos técnicos em sua área de atuação; realizar outras atividades compatíveis
com a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
HISTORIADOR</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em História com
registro no órgão de fiscalização.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições</span><span originalstyle="color:black">: atuar na composição, na preservação e na organização de
acervos documentais (escritos, orais e iconográficos) relacionados à Assembleia
Legislativa; receber, avaliar, descrever, arranjar, custodiar e conservar toda
documentação do Poder Legislativo de Pernambuco; atuar na área de preservação e
conservação dos bens de natureza material e imaterial do Poder Legislativo de
Pernambuco; promover e coordenar o intercâmbio com outros arquivos e centros de
documentação a nível estadual, nacional e internacional; elaborar e executar
projetos nas áreas de pesquisa histórica e de preservação do patrimônio
cultural do legislativo e sociedade brasileira; executar programas de
treinamento na área de gestão documental; responsabilizar-se pelo atendimento
das demandas de informações decorrentes da atividade institucional da
Assembleia Legislativa; participar do planejamento, do desenvolvimento, da
manutenção e da gestão de bancos de dados, exclusivos ou compartilhados, de
setores da instituição; produzir e promover a divulgação da memória da
Assembleia Legislativa; realizar outras atividades compatíveis com a
especialidade.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
CONSULTORIA LEGISLATIVA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:
</span><span originalstyle="color:black">curso superior de graduação.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">Realizar atividades de nível superior e
especializado, de consultoria e assessoramento técnico à Mesa, às Comissões e
aos deputados no desempenho de suas competências institucionais, sobre matéria
relacionada à sua área de atuação; Elaborar notas Técnicas opinativas sobre proposições
a requerimento de Comissão, de Presidente de Comissão ou de Relator; Elaborar
minutas de proposições legislativas, de pareceres sobre proposições, de
pareceres avulsos e de pronunciamentos e de relatórios técnicos; Realizar
pesquisas e estudos nas áreas jurídica, financeira, econômica, orçamentária e
demais temas de interesse para a atividade legiferante; Prestar assessoramento
às atividades parlamentares de fiscalização e controle externo da administração
pública e fornecer subsídios aos processos de acompanhamento e avaliação de
políticas públicas, conforme sua área de atuação; Ministrar palestras e cursos
promovidos pela instituição sobre assunto relacionado à sua área de atuação;
Elaborar e divulgar estudos técnicos opinativos sobre elaboração, execução,
acompanhamento e fiscalização de planos e orçamentos públicos, sobre matérias
de interesse institucional; realizar outras atividades compatíveis com a
especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
ASSISTÊNCIA SOCIAL</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:</span><span originalstyle="color:black"> curso superior de graduação com formação em Serviço Social
e registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">participar de projetos e programas de
adequação funcional do servidor e de preparação para a aposentadoria;
desenvolver em conjunto com profissionais das áreas de medicina, de psicologia
e outras o estudo e o acompanhamento de casos específicos de natureza social; -
prestar atendimento familiar em caso de moléstia grave e de falecimento de
servidor; - elaborar relatórios técnicos e sistematizados, por meio de dados
estatísticos, das atividades de assistência social; - realizar avaliação
socioeconômica do servidor para acompanhamento de processo funcional; - emitir
laudos e pareceres técnicos relacionados a matéria específica de Serviço
Social; realizar estudos, orientar, implantar, coordenar e executar projetos e
programas na área de Serviço Social; ministrar palestras e cursos promovidos
pela instituição sobre assunto relacionado à sua área de atuação; realizar
outras atividades compatíveis com a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
BIBLIOTECONOMIA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em
Biblioteconomia com registro no órgão de fiscalização.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">atuar na composição, na preservação e na
organização de acervos de bibliotecas e de centros de documentação da
instituição; definir critérios para seleção, armazenamento, catalogação e
recuperação, em meios diversos, de informações de interesse da instituição; -
participar do planejamento, do desenvolvimento, da manutenção e da gestão de
bancos de dados, exclusivos ou compartilhados, de setores da instituição;
elaborar e manter disponível e atualizado o vocabulário controlado para
representação de assuntos em bancos de dados institucionais; - atualizar bases
de dados de sistemas de informação da instituição; - atender a demandas de
informações dos públicos interno e externo relacionadas com atividades
institucionais; executar programas de treinamento para operadores e usuários de
bancos de dados setoriais; realizar outras atividades compatíveis com a
especialidade</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
CONTABILIDADE</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Ciências
Contábeis e registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">elaborar ou auxiliar na elaboração de balanços,
balancetes e demonstrativos da execução orçamentária, financeira e contábil bem
como análises, pareceres e recomendações necessários à instrução dos processos
de prestação de contas mensais e anuais dos ordenadores de despesa; examinar o
plano de contas e registro dos fatos da gestão orçamentária, financeira e
patrimonial da instituição; atuar como assistente técnico em processos
judiciais, por indicação do órgão responsável pela representação da Assembleia
nesses processos; prestar assessoramento no processo de elaboração da proposta
orçamentária da instituição e realizar outras atividades compatíveis com a
especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
ENGENHARIA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:</span><span originalstyle="color:black"> curso superior de graduação com formação em Engenharia
Civil e registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">realizar atividades de planejamento, projeto,
cálculo, coordenação e fiscalização de serviços referentes a edificações,
estruturas, redes hidráulicas e combate a incêndio; elaborar orçamentos, pareceres,
laudos, relatórios, especificar materiais e realizar vistorias; prestar
assessoramento na elaboração de editais de licitação para execução de obras,
prestação de serviços e aquisição de bens; fiscalizar o cumprimento dos
contratos administrativos em seus aspectos técnicos; promover a capacitação de
pessoal; acompanhar os processos de aprovação de projetos de obras civis nos
órgãos competentes; realizar atividades de planejamento, projeto, cálculo,
coordenação e fiscalização relacionadas a propagação de ondas de rádio e
antenas, comunicação de dados, redes de computação, redes de telecomunicações,
comunicação via satélite e micro-ondas, comunicação multimídia, telefonia,
rádio, televisão, infraestrutura e serviços de comunicações; planejar,
especificar, projetar e implementar sistemas de comunicações e de transmissão
de voz, dados e imagens; operar, inspecionar, periciar e realizar manutenção de
equipamentos e sistemas de telecomunicações; prestar consultoria técnica,
supervisionar e coordenar estudos e projetos de sistemas de comunicações;
promover a capacitação de pessoal; realizar atividades de planejamento,
projeto, cálculo, coordenação e fiscalização de serviços referentes a
instalações elétricas, acionamentos eletromecânicos, cabeamento estruturado, sistemas
de medição e controle elétrico e materiais elétricos; elaborar orçamentos,
pareceres, laudos, relatórios e realizar vistorias; operar, inspecionar,
periciar e realizar manutenção de equipamentos elétricos; - prestar
assessoramento na elaboração de editais de licitação para execução de obras,
prestação de serviços e aquisição de bens, relacionados com sua área de
atuação; - fiscalizar o cumprimento dos contratos administrativos em seus
aspectos técnicos; promover a capacitação de pessoal; acompanhar os processos
de aprovação de projetos elétricos nos órgãos competentes; realizar atividades
de planejamento, projetos, cálculos, coordenação e fiscalização relacionadas a
processos mecânicos, máquinas de tração mecânica, elevadores, bombas e
instalações de bombeamento, veículos automotores, sistemas de produção,
transmissão e utilização de calor, sistemas de refrigeração e de ar
condicionado; elaborar orçamentos, pareceres, laudos, relatórios e realizar
vistorias; operar, inspecionar, periciar e realizar manutenção de equipamentos
elétricos; prestar assessoramento na elaboração de editais de licitação para
execução de obras, prestação de serviços e aquisição de bens, relacionados com
sua área de atuação; fiscalizar o cumprimento dos contratos administrativos nos
seus aspectos técnicos; promover a capacitação de pessoal; acompanhar os
processos de aprovação de projetos elétricos nos órgãos competentes; realizar
outras atividades compatíveis com a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
ENFERMAGEM</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Enfermagem e
registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">planejar, coordenar e executar os serviços de
assistência de enfermagem na Assembleia Legislativa; orientar, executar e supervisionar
as tarefas de esterilização de material médico e demais atividades de controle
sistemático de infecções e contaminações nos ambulatórios e consultórios do
setor; participar do planejamento, da execução e da avaliação de programas de
promoção da saúde e prevenção de doenças e de higiene e segurança no trabalho;
supervisionar o trabalho do Técnico em Enfermagem; planejar e desenvolver, em
parceria com outros setores da instituição, campanhas e programas sobre
qualidade de vida e melhoria das condições funcionais na Assembleia
Legislativa; - pesquisar, desenvolver e implementar novas técnicas e
metodologias próprias de sua área de atuação; - ministrar palestras e cursos
promovidos pela instituição sobre assunto relacionado à sua área de atuação;
realizar outras atividades compatíveis com a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
COMUNICAÇÃO SOCIAL</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Comunicação
Social na área de Jornalismo e registro no órgão de fiscalização profissional
competente.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">realizar a cobertura jornalística onde houver
demanda da instituição; divulgar as atividades institucionais de acordo com a
orientação da Assembleia Legislativa; - redigir textos jornalísticos
relacionados às atividades da instituição e divulgá-los nos meios de
comunicação; - prestar assessoria de comunicação ao Presidente e a outras
autoridades da instituição; assessorar e acompanhar o trabalho dos jornalistas
de outros órgãos e entidades que necessitarem de informações sobre as atividades
da instituição; - participar do planejamento, da execução e da avaliação de
pesquisas de opinião pública para fins institucionais; - propor, participar da
elaboração e acompanhar a execução de ações de "marketing"
institucional e de publicidade de interesse da instituição; - participar da
elaboração, da execução e da avaliação de estratégias de interlocução e
posicionamento da instituição com seus públicos; participar do planejamento, da
execução e da avaliação de projetos especiais de comunicação; coordenar a
gestão da página da Assembleia Legislativa na internet e na intranet; coordenar
e executar o credenciamento dos jornalistas e dos meios de comunicação para a
cobertura jornalística das atividades institucionais; - produzir, redigir
roteiros e editar programas de entrevistas, reportagens, telejornal,
documentários e vídeos institucionais; selecionar áudio e imagens para o
arquivo permanente dos sistemas de rádio e TV da instituição; - coordenar a
gravação e a transmissão ao vivo de reuniões e eventos institucionais; -
ancorar jornal, debate ou entrevistas gravadas ou transmitidas ao vivo;
redigir, gravar e enviar material jornalístico da instituição às emissoras de
rádio que o solicitarem; - coordenar o recebimento de matérias gravadas em
áudio enviadas à Assembleia Legislativa por emissoras de rádio; realizar outras
atividades compatíveis com a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
MEDICINA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Medicina com
registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">proceder ao exame de pacientes, realizar
diagnósticos e tratamentos clínicos e de natureza profilática; requisitar e
interpretar exames complementares; - orientar e controlar o trabalho de
enfermagem; atuar no controle de moléstias transmissíveis, na realização de
inquéritos epidemiológicos e em trabalhos de educação sanitária; proceder ao
exame de candidatos ao ingresso nos serviços da instituição e ao exame
periódico dos servidores; - fornecer atestados e laudos médicos; - realizar
perícias médicas; - realizar estudos, orientar, implantar, coordenar e executar
projetos e programas especiais de saúde no âmbito da instituição; planejar e
desenvolver, em parceria com outros órgãos da instituição, campanhas e
programas sobre melhorias das condições funcionais e de qualidade de vida; -
pesquisar, desenvolver e implementar novas técnicas e metodologias de sua área
de atuação; realizar outras atividades compatíveis com a especialidade do
cargo.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
ODONTOLOGIA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:</span><span originalstyle="color:black"> curso superior de graduação com formação em Odontologia e
registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">- realizar procedimentos odontológicos
profiláticos e de atendimento de urgência; elaborar laudos, perícias,
atestados, relatórios e fichas odontológicas; proceder ao exame periódico dos
servidores; planejar e desenvolver, em parceria com outros órgãos da
instituição, campanhas e programas sobre melhorias das condições funcionais e
de qualidade de vida; pesquisar, desenvolver e implementar novas técnicas e
metodologias de sua área de atuação; realizar outras atividades compatíveis com
a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
PSICOLOGIA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade</span><span originalstyle="color:black">: curso superior de graduação com formação em Psicologia e
registro no órgão de fiscalização profissional competente.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">elaborar diagnóstico psicológico, inclusive
com aplicação e interpretação de testes, quando necessário, visando a orientar
e a acompanhar o processo de adequação funcional do servidor; prestar
assessoramento à área de recursos humanos nas ações relacionadas a gestão de
pessoal; participar da elaboração, da implementação e do acompanhamento de
políticas de recursos humanos; acompanhar processo de psicoterapia do servidor,
quando necessário; - planejar e desenvolver, em parceria com outros órgãos da
instituição, campanhas e programas sobre melhorias das condições funcionais e
de qualidade de vida; pesquisar, desenvolver e implementar novas técnicas e
metodologias de sua área de atuação; realizar outras atividades relacionadas ao
cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
RELAÇÕES PÚBLICAS</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:</span><span originalstyle="color:black"> curso superior de graduação com formação em Comunicação
Social na área de Relações Públicas e registro no órgão de fiscalização
profissional competente.</span></p>

<p className="MsoNormal"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">criar e manter canais de relacionamento entre
a Assembleia e seus públicos; prestar assessoria de relações públicas,
infraestrutura e logística em eventos realizados pela Assembleia Legislativa e
acompanhar eventos promovidos por terceiros em que haja representação da
instituição; planejar, executar e avaliar projetos especiais de comunicação;
propor ações de integração dos servidores; planejar e desenvolver campanhas
institucionais dirigidas aos públicos estratégicos e à formação da opinião
pública; planejar, junto com outros setores da instituição, as providências
necessárias à recepção dos novos Deputados e coordenar as atividades de
contato, ambientação e acompanhamento a serem implementadas para esse fim;
realizar outras atividades relacionadas ao cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal"><span originalstyle="color:black">2. classNameE II</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">CARGO:
TÉCNICO LEGISLATIVO</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:
</span><span originalstyle="color:black">curso superior de graduação.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
PROCESSO LEGISLATIVO</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
</span><span originalstyle="color:black">Realizar atividades de coordenação e execução
especializada, em graus de maior complexidade, referentes a estudos, pesquisas,
análises e projetos sobre administração em geral, organização e métodos,
atividades de pesquisa e assistência técnica legislativa inclusive
acompanhamento da tramitação de proposições, bem como atividades de natureza
repetitiva, envolvendo execução qualificada, sob supervisão e orientação de
trabalhos de apoio, em grau auxiliar, ao desenvolvimento dos trabalhos de
pesquisa legislativa. Acompanhar a tramitação dos atos e procedimentos
administrativos e das proposições legislativas. Manter organizados os anais da
instituição. Realizar outras atribuições compatíveis com a especialidade do
cargo</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
INFORMÁTICA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
- </span><span originalstyle="color:black">Executar atividades envolvendo programação,
coordenação ou execução especializada, em grau de variada complexidade,
referentes a trabalhos de Informática Legislativa incluindo técnicas de
teleprocessamento; técnicas de operação de computador; técnicas de controle de
qualidade. Operar sistemas de computadores e microcomputadores, monitorando o
desempenho dos aplicativos, recursos de entrada e saída de dados, recursos de
armazenamento de dados, registros de erros, consumo da unidade central de
processamento, recursos de rede e disponibilidade dos aplicativos. Assegurar o
funcionamento do hardware e do software. Garantir a segurança das informações,
por meio de cópias de segurança e armazenando-as em local prescrito,
verificando acesso lógico de usuário e destruindo informações sigilosas
descartadas. Projetar, implantar e realizar a manutenção de sistemas de
aplicações. Executar e acompanhar outras atividades que envolvam o apoio ao
usuário de informática. Desenvolver sistemas e aplicações, determinando
interface gráfica, critérios ergonômicos de navegação, montagem da estrutura de
banco de dados e codificação de programa. Projetar, implantar e realizar a
manutenção de sistemas de aplicações. </span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Especialidade:
TAQUIGRAFIA</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
- </span><span originalstyle="color:black">Executar atividades de natureza pouco
repetitiva, envolvendo supervisão, coordenação, orientação e execução dos
trabalhos de gravação, registro taquigráfico, interpretação, revisão e redação
final de debates e pronunciamentos, bem assim o planejamento da elaboração dos
originais para publicação no órgão oficial. Alimentar o Banco de
Pronunciamentos e o Banco de Dados Comissão. Realizar outras atribuições compatíveis
com a especialidade do cargo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">3.
classNameE III</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">CARGO:
POLICIAL LEGISLATIVO</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:
</span><span originalstyle="color:black">curso de ensino médio</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
- </span><span originalstyle="color:black">Efetuar atividades típicas da Polícia
Legislativa da ALEPE, quais sejam: a segurança do Presidente da ALEPE, em
qualquer localidade do território nacional e no exterior; a segurança dos
Deputados e autoridades brasileiras e estrangeiras, nas dependências sob a
responsabilidade da ALEPE; a segurança dos Deputados e de servidores em
qualquer localidade do território nacional e no exterior, quando determinado
pelo Presidente da ALEPE; o policiamento nas dependências da ALEPE; o apoio às
Comissões Parlamentares de Inquérito; as de revista, busca e apreensão; as de
inteligência; as de registro e de administração inerentes à polícia, as de
investigação e de inquérito policial; e executar outras tarefas correlatas.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">4.
classNameE IV</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">CARGO:
AGENTE LEGISLATIVO</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Escolaridade:
</span><span originalstyle="color:black">curso de ensino médio</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">&nbsp;</span></p>

<p className="MsoNormal" originalstyle="text-align:justify"><span originalstyle="color:black">Atribuições:
- </span><span originalstyle="color:black">Executar atividades de apoio
técnico-administrativo, de média complexidade, que envolvem elaboração e
conferência de cálculos, digitação, envio e arquivamento de documentos, bem
como, auxiliar no planejamento, na execução, no acompanhamento e na avaliação
de projetos e estudos de interesse do Poder Legislativo.</span></p>

<p className="MsoNormal" originalstyle="text-align:justify">&nbsp;</p>

<p className="MsoNormal" originalstyle="text-align:justify;text-indent:30.0pt">Palácio
Joaquim Nabuco, Recife, 27 de novembro do ano de 2013, 197º da Revolução
Republicana Constitucionalista e 192º da Independência do Brasil.</p>

<p className="MsoNormal" originalstyle="text-align:justify">&nbsp;</p>

<p className="MsoNormal" align="center" originalstyle="text-align:center">GUILHERME UCHÔA</p>

<p className="MsoNormal" align="center" originalstyle="text-align:center"><span originalstyle="font-family:&quot;Helvetica&quot;,&quot;sans-serif&quot;">Presidente</span></p>

</div>





  
</div>


</article>
            </div>
        </Col>
    </Row>
}